import { ZONE_TYPE_LABELS } from '../../utils/inventoryLabels';

/** Sentinel of the zone filter when it is not narrowing anything. */
export const ALL_ZONES = 'all';

/** The zones a location can belong to, as the form offers them. */
export const ZONE_OPTIONS = Object.entries(ZONE_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const ZONE_FILTER_OPTIONS = [{ value: ALL_ZONES, label: 'Todas' }, ...ZONE_OPTIONS];

/**
 * The zones whose stock can be reserved and sold. Anything received sits in
 * "Recepción" until somebody stores it, and that is what makes putting away a
 * real step.
 */
export const SELLABLE_ZONES = ['storage', 'picking'];

/** The columns of the bulk-upload sheet, as the server reads them. Only the first is required. */
export const SLOT_TEMPLATE_COLUMNS = ['Ubicación', 'Código', 'Zona', 'Recorrido', 'Capacidad'];

/** Three rows that show one of each: the dock, a rack, a picking face. */
export const SLOT_TEMPLATE_EXAMPLE = [
  { Ubicación: 'RECEPCION-01', Código: 'REC-01', Zona: 'Recepción', Recorrido: 0, Capacidad: 0 },
  { Ubicación: 'A-01-01', Código: 'A-01-01', Zona: 'Almacenaje', Recorrido: 10, Capacidad: 100 },
  { Ubicación: 'PICKING-01', Código: 'PICK-01', Zona: 'Picking', Recorrido: 1, Capacidad: 50 },
];

export const EMPTY_SLOT_FORM = {
  name: '',
  code: '',
  zone_type: 'storage',
  pick_rank: 0,
  capacity: 0,
  is_active: true,
};
